export default __webpack_public_path__ + "static/media/analyticsIQ.75743243.svg";